import mietpreisbremse from '../../fields/cases/mietpreisbremse';

export const QUERY_GET_MPB_CASE = /* GraphQL */ `
	query($id: String!) {
		getMietpreisbremseCase(id: $id) {
			${mietpreisbremse}
		}
	}
`;
